export enum Mode {
  DISPLAY = 'DISPLAY',
  EDIT = 'EDIT',
}
